<div class="divisa-space-between card-reservacion"  *ngIf="typoCard != 'normal'">
  <div class="card-reservacion-moneda mx-mb-auto mb-3 col-12 col-md-6 pl-md-0">
    <div class="card-reservacion-header subtitulo">
      {{ pagarTexto }}
    </div>
    <div class="card-reservacion-body my-auto divisa-space-between center-y">
      <ul class="card-reservacion-body-currency divisa-col-2">
        <img [src]="cotizacion?.from?.iconPath" alt="">
        <span class="currency-name">{{ cotizacion?.from?.name }}</span>
      </ul>
      <div class="divisa-col-9">
        <div class="divisa-col">
          <span class="cuerpo-2 mb-2">{{ cotizacion?.from?.fullName }} </span>
          <span class="subtitulo">{{ cotizacion?.in | currency }}</span>
        </div>
      </div>
    </div>
  </div>
  <div class="card-reservacion-moneda mx-mb-auto mb-3 col-12 col-md-6 pr-md-0">
    <div class="card-reservacion-header subtitulo">
      {{ recibiTexto }}
    </div>
    <div class="card-reservacion-body my-auto divisa-space-between center-y">
      <ul class="card-reservacion-body-currency divisa-col-2">
        <img [src]="cotizacion?.to?.iconPath" alt="">
        <span class="currency-name">{{ cotizacion?.to?.name }}</span>
      </ul>
      <div class="divisa-col-9">
        <div class="divisa-col">
          <span class="cuerpo-2 mb-2">{{ cotizacion?.to?.fullName }} </span>
          <span class="subtitulo">{{ cotizacion?.out | currency }}</span>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="divisa-space-between card-reservacion" *ngIf="typoCard != 'vencida'">
	<div class="card-reservacion-moneda mx-auto mb-3">
	  <div class="card-reservacion-header subtitulo">
		  {{ pagarTexto }}
	  </div>
	  <div class="card-reservacion-body my-auto divisa-space-between center-y">
      <ul class="card-reservacion-body-currency divisa-col-2">
        <img [src]="cotizacion?.from?.currency?.iconPath" alt="">
        <span class="currency-name">{{ cotizacion?.from?.currency?.name }}</span>
      </ul>
      <div class="divisa-col-9">
        <div class="divisa-col">
          <span class="cuerpo-2 mb-2">{{ cotizacion?.from?.currency?.fullName }} </span>
          <span class="subtitulo">{{ cotizacion?.in | currency }}</span>
        </div>
      </div>
	  </div>
	</div>
	<div class="card-reservacion-moneda mx-auto mb-3">
	  <div class="card-reservacion-header subtitulo">
      {{ recibiTexto }}
	  </div>
	  <div class="card-reservacion-body my-auto divisa-space-between center-y">
      <ul class="card-reservacion-body-currency divisa-col-2">
        <img [src]="cotizacion?.to?.currency?.iconPath" alt="">
        <span class="currency-name">{{ cotizacion?.to?.currency?.name }}</span>
      </ul>
      <div class="divisa-col-9">
        <div class="divisa-col">
          <span class="cuerpo-2 mb-2">{{ cotizacion?.to?.currency?.fullName }} </span>
          <span class="subtitulo">{{ cotizacion?.out | currency }}</span>
        </div>
      </div>
	  </div>
  </div>
</div>
